export const getRawRecordStatusValue = (statusItem: any): string => {
	if (statusItem === null || statusItem === undefined) {
		return "";
	}

	if (typeof statusItem === "string" || typeof statusItem === "number") {
		return String(statusItem);
	}

	if (typeof statusItem === "object") {
		return String(
			statusItem.status ??
			statusItem.recordStatus ??
			statusItem.statusNotification ??
			statusItem.name ??
			statusItem.value ??
			""
		);
	}

	return String(statusItem);
};

export const getLastRecordStatus = (recordStatus: any): string => {
	if (Array.isArray(recordStatus)) {
		if (recordStatus.length === 0) {
			return "";
		}

		return getRawRecordStatusValue(recordStatus[recordStatus.length - 1]);
	}

	return getRawRecordStatusValue(recordStatus);
};

export const normalizeRecordStatus = (
	recordStatus: any,
	recordType = ""
): string => {
	const rawValue = getLastRecordStatus(recordStatus).trim().toUpperCase();

	if (!rawValue) {
		return "-";
	}

	const firstValue = rawValue.split(" ")[0];

	if (firstValue === "0") return "PENDING";
	if (firstValue === "1") return "CANCELED";
	if (firstValue === "2") return "OK";
	if (firstValue === "3") return "REFUNDED";

	if (firstValue === "4") {
		return String(recordType).toUpperCase() === "WITHDRAWAL"
			? "COMPLETED"
			: "OK";
	}

	if (firstValue === "CANCELLED") return "CANCELED";

	return firstValue;
};

export const getRecordStatusLabel = (
	recordStatus: any,
	recordType = ""
): string => {
	const status = normalizeRecordStatus(recordStatus, recordType);

	switch (status) {
		case "PENDING":
			return "Pendente";
		case "COMPLETED":
			return "Completo";
		case "OK":
			return "OK";
		case "CANCELED":
			return "Cancelado";
		case "REFUNDED":
			return "Reembolsado";
		default:
			return status;
	}
};

export const getRecordStatusClasses = (
	recordStatus: any,
	recordType = ""
): string => {
	const status = normalizeRecordStatus(recordStatus, recordType);

	switch (status) {
		case "COMPLETED":
			return "bg-emerald-100 text-emerald-800 ring-emerald-200";
		case "PENDING":
			return "bg-yellow-100 text-yellow-800 ring-yellow-200";
		case "OK":
			return "bg-blue-100 text-blue-800 ring-blue-200";
		case "CANCELED":
			return "bg-red-100 text-red-800 ring-red-200";
		case "REFUNDED":
			return "bg-purple-100 text-purple-800 ring-purple-200";
		default:
			return "bg-gray-100 text-gray-800 ring-gray-200";
	}
};

export const isPendingRecordStatus = (
	recordStatus: any,
	recordType = ""
): boolean => {
	return normalizeRecordStatus(recordStatus, recordType) === "PENDING";
};